import { useScrollReveal } from "../useScrollReveal";

function TimelineItem({ item, index }) {
  const [ref, visible] = useScrollReveal(0.1);

  return (
    <div ref={ref} style={{
      display: "grid", gridTemplateColumns: "180px 1fr", gap: "2rem",
      padding: "2rem 0", borderBottom: "1px solid var(--border)",
      opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(20px)",
      transition: `opacity 0.5s ease ${index * 0.1}s, transform 0.5s ease ${index * 0.1}s`,
    }} className="timeline-item">
      <div style={{ paddingTop: "0.2rem" }}>
        <div style={{ fontSize: "0.8rem", color: "var(--text-muted)", marginBottom: "0.25rem" }}>{item.period}</div>
        <div style={{ fontSize: "0.85rem", fontWeight: 500, color: "var(--text-secondary)" }}>{item.company}</div>
      </div>
      <div>
        <h3 style={{ fontFamily: "var(--serif)", fontSize: "1.3rem", marginBottom: "0.5rem" }}>{item.role}</h3>
        <p style={{ fontSize: "0.9rem", color: "var(--text-secondary)", lineHeight: 1.65, fontWeight: 300, marginBottom: "1rem" }}>{item.desc}</p>
        <ul style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
          {item.achievements.map((a, i) => (
            <li key={i} style={{ fontSize: "0.85rem", color: "var(--text-secondary)", fontWeight: 300, display: "flex", alignItems: "flex-start", gap: "0.6rem" }}>
              <span style={{ color: "var(--text-muted)", flexShrink: 0 }}>→</span>
              {a}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function Experience({ data }) {
  return (
    <section id="experience" style={{ padding: "6rem 0", background: "var(--off-white)" }}>
      <div className="section-inner">
        <div className="section-label">Experience</div>
        <h2 className="section-title">Where I've <em>worked</em></h2>
        <div>
          {data.experience.map((item, i) => <TimelineItem key={item.company} item={item} index={i} />)}
        </div>
      </div>
      <style>{`
        .timeline-item { grid-template-columns: 180px 1fr; }
        @media (max-width: 768px) { .timeline-item { grid-template-columns: 1fr !important; gap: 0.5rem !important; } }
      `}</style>
    </section>
  );
}
